import React, { useState, useEffect } from 'react';
import SearchHeader from './SearchHeader';
import SearchOptions from './SearchOptions';
import CategoryTree from './CategoryTree';
import VehicleSpecs from './VehicleSpecs';
import SavedSpecs from './SavedSpecs';
import SearchResults from './SearchResults';
import "./newSpareParts.css";
const SearchPage = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [activeTab, setActiveTab] = useState('general'); // 'general', 'categories', 'specs'
    const [searchResults, setSearchResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [savedSpecs, setSavedSpecs] = useState([]);

    // أضف هذه الحالة
    const [viewMode, setViewMode] = useState('grid');
    const [sortBy, setSortBy] = useState('default');
    // دوال مساعدة
    const getRandomGradient = () => {
        const gradients = [
            'from-blue-400 to-cyan-300',
            'from-purple-500 to-pink-400',
            'from-green-400 to-teal-300',
            'from-orange-400 to-red-400',
            'from-indigo-500 to-purple-400',
            'from-yellow-400 to-orange-300'
        ];
        return gradients[Math.floor(Math.random() * gradients.length)];
    };

    const getSubCategory = (category) => {
        const subCategories = {
            'فلتر': 'نظام المحرك',
            'فرامل': 'نظام الفرامل',
            'زيت': 'نظام المحرك',
            'إطارات': 'العجلات',
            'كهرباء': 'نظام الكهرباء'
        };
        return subCategories[category] || 'عام';
    };
    // قم بتحويل بيانات results لتتضمن الحقول الجديدة
    const enhancedResults = searchResults.map(result => ({
        ...result,
        // imageColor: getRandomGradient(),
        imageUrl: "/assets/images/parts/PARTS_TOYOTA-AR-no-img.png",
        subCategory: getSubCategory(result.category),
        rating: Math.random() * (5 - 3.5) + 3.5, // قيمة عشوائية بين 3.5 و 5
        reviews: Math.floor(Math.random() * 200) + 50,
        description: 'قطعة غيار أصلية عالية الجودة تناسب معظم موديلات السيارات',
        warranty: 'ضمان 12 شهر',
        delivery: 'توصيل سريع',
        stock: Math.floor(Math.random() * 50) + 5,
        isPromo: Math.random() > 0.7
    }));



    // تحميل المواصفات المحفوظة من localStorage عند التحميل الأول
    useEffect(() => {
        const saved = localStorage.getItem('savedVehicleSpecs');
        if (saved) {
            setSavedSpecs(JSON.parse(saved));
        }
    }, []);

    // حفظ المواصفات في localStorage عند التغيير
    useEffect(() => {
        localStorage.setItem('savedVehicleSpecs', JSON.stringify(savedSpecs));
    }, [savedSpecs]);

    const handleSearch = (type, data) => {
        setIsLoading(true);

        // محاكاة طلب بحث (في تطبيق حقيقي، سيكون هناك طلب API)
        setTimeout(() => {
            let results = [];

            if (type === 'general') {
                results = [
                    { id: 1, name: 'فلتر هواء', partNumber: 'AIRF-1234', brand: 'Toyota', category: 'فلتر', price: '45 ريال', availability: 'متوفر' },
                    { id: 2, name: 'مكابح أمامية', partNumber: 'BRAK-5678', brand: 'Toyota', category: 'فرامل', price: '120 ريال', availability: 'متوفر' },
                    { id: 3, name: 'زيت محرك', partNumber: 'OIL-9012', brand: 'Toyota', category: 'زيت', price: '85 ريال', availability: 'متوفر' },
                    { id: 4, name: 'إطار 18 بوصة', partNumber: 'TIRE-3456', brand: 'Michelin', category: 'إطارات', price: '350 ريال', availability: 'غير متوفر' },
                    { id: 5, name: 'بطارية', partNumber: 'BATT-7890', brand: 'Toyota', category: 'كهرباء', price: '280 ريال', availability: 'متوفر' },
                ];
            } else if (type === 'category') {
                results = [
                    { id: 6, name: 'شمعات إشعال', partNumber: 'SPAR-1234', brand: 'NGK', category: data, price: '65 ريال', availability: 'متوفر' },
                    { id: 7, name: 'كابلات شمعات', partNumber: 'WIRE-5678', brand: 'Toyota', category: data, price: '40 ريال', availability: 'متوفر' },
                ];
            } else if (type === 'specs') {
                results = [
                    { id: 8, name: 'مرشح وقود', partNumber: 'FUEL-1234', brand: 'Toyota', category: 'فلتر', price: '95 ريال', availability: 'متوفر', vehicle: data },
                    { id: 9, name: 'حساس أكسجين', partNumber: 'O2S-5678', brand: 'Toyota', category: 'حساسات', price: '180 ريال', availability: 'متوفر', vehicle: data },
                ];
            }

            setSearchResults(results);
            setIsLoading(false);
        }, 800);
    };

    const handleSaveSpecs = (specs) => {
        const newSpec = {
            id: Date.now(),
            ...specs,
            date: new Date().toLocaleDateString('ar-SA')
        };
        setSavedSpecs([...savedSpecs, newSpec]);
    };

    const handleDeleteSpec = (id) => {
        setSavedSpecs(savedSpecs.filter(spec => spec.id !== id));
    };

    const handleUseSavedSpec = (spec) => {
        setActiveTab('specs');
        handleSearch('specs', spec);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <div className="container mt-40 sm:mt-0 mx-auto px-4 py-8">
                <SearchHeader
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    onSearch={() => handleSearch('general', searchQuery)}
                />

                <SearchOptions activeTab={activeTab} setActiveTab={setActiveTab} />

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8">
                    <div className="lg:col-span-2 space-y-8">
                        {activeTab === 'general' && (
                            <div className="bg-white rounded-2xl shadow-xl p-6">
                                <h2 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-3">البحث العام عن قطع الغيار</h2>
                                <div className="mb-6">
                                    <p className="text-gray-600 mb-4 text-xl">ابحث عن أي قطعة غيار باستخدام الرقم التسلسلي أو اسم القطعة أو الوصف.</p>
                                    <div className="flex">
                                        <input
                                            type="text"
                                            className="flex-grow p-4 text-2xl border border-gray-300 rounded-r-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-800"
                                            placeholder="أدخل رقم القطعة أو اسم القطعة للبحث..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            onKeyPress={(e) => e.key === 'Enter' && handleSearch('general', searchQuery)}
                                        />
                                        <button
                                            className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-6 rounded-l-lg font-semibold hover:from-blue-700 hover:to-indigo-800 transition-all duration-300"
                                            onClick={() => handleSearch('general', searchQuery)}
                                        >
                                            بحث
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'categories' && (
                            <div className="bg-white rounded-2xl shadow-xl p-6">
                                <CategoryTree onSelectCategory={(category) => {
                                    console.log('Category selected:', category);
                                    // هنا يمكنك تنفيذ البحث بناءً على الفئة المختارة
                                    handleSearch('category', category.name);
                                }} />
                            </div>
                        )}

                        {activeTab === 'specs' && (
                            <div className="bg-white rounded-2xl shadow-xl p-6">
                                <h2 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-3">البحث حسب مواصفات السيارة</h2>
                                <VehicleSpecs onSearch={handleSearch} onSave={handleSaveSpecs} />
                            </div>
                        )}

                        <div className="bg-white rounded-2xl shadow-xl p-6">
                            <h2 className="text-3xl font-bold text-gray-800 mb-2 border-b pb-3">نتائج البحث</h2>
                            <SearchResults
                                results={enhancedResults}
                                isLoading={isLoading}
                                viewMode={viewMode}
                                onViewModeChange={setViewMode}
                                onSortChange={(value) => {
                                    setSortBy(value);
                                    // قم بتنفيذ منطق الترتيب هنا
                                }}
                            />
                        </div>
                    </div>

                    <div className="space-y-8">
                        <SavedSpecs
                            specs={savedSpecs}
                            onUseSpec={handleUseSavedSpec}
                            onDeleteSpec={handleDeleteSpec}
                        />
                        <CategoryTree onSelectCategory={(category) => {
                            console.log('Category selected:', category);
                            // هنا يمكنك تنفيذ البحث بناءً على الفئة المختارة
                            handleSearch('category', category.name);
                        }} />
                        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-xl p-6 border border-blue-100">
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">نصائح للبحث الفعال</h3>
                            <ul className="space-y-3">
                                <li className="flex items-start">
                                    <div className="bg-blue-100 p-1 rounded-md mr-3 mt-1">
                                        <svg className="w-7 h-7 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <span className="text-gray-700 text-2xl">استخدم رقم القطعة الأصلي للحصول على أفضل نتيجة</span>
                                </li>
                                <li className="flex items-start">
                                    <div className="bg-blue-100 p-1 rounded-md mr-3 mt-1">
                                        <svg className="w-7 h-7  text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <span className="text-gray-700 text-2xl">احفظ مواصفات سيارتك لتسريع البحث في المرات القادمة</span>
                                </li>
                                <li className="flex items-start">
                                    <div className="bg-blue-100 p-1 rounded-md mr-3 mt-1">
                                        <svg className="w-7 h-7  text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <span className="text-gray-700 text-2xl">استخدم الفئات للتصفح عندما لا تعرف رقم القطعة</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchPage;